class HttpError extends Error {
  constructor(message, statusCode, body = null) {
    super(message);
    this.statusCode = statusCode;
    this.name = 'HttpError';
    this.body = body;
  }
}

export default HttpError;
